import Content from "components/helpers/action-text/content";
import useAppContext from "lib/hooks/use-app-context";
import List from "components/helpers/candidates/list";
import {isBlankHTML} from "lib/ext/string";

export default function Sponsored() {
  const {page} = useAppContext();
  const params = {sponsored: true};

  if(page.tag_id) { params.tag_ids = page.tag_id.toString(); }

  return (
    <div className="container">
      <div className="max-w-screen-lg mx-auto">
        {!isBlankHTML(page.content) && (
          <div className="custom-html">
            <Content html={page.content} />
          </div>
        )}
        <List params={params} />
      </div>
    </div>
  );
}
